import React, { useState } from 'react';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from '@mui/lab';
import { Typography, Box, Card, CardContent, TextField, InputAdornment, } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SearchIcon from '@mui/icons-material/Search';

function ActivityLog() {
  const logs = [
    { time: '14:00 - Yesterday', event: 'Signed contract', details: 'Lorem ipsum dolor sit amet...', icon: <AssignmentIcon /> },
    { time: '14:30 - Sep 28, 2022', event: 'Made call', details: 'Successful call - 5m42s', icon: <PhoneIcon  /> },
    { time: '16:00 - Sep 25, 2022', event: 'Negotiated', details: 'Negotiation notes...', icon: <AssignmentIcon  /> },
    { time: '14:00 - Sep 20, 2022', event: 'Sent email', details: 'Email content preview...', icon: <EmailIcon /> },
  ];

  const [searchTerm, setSearchTerm] = useState('');

  const filteredLogs = logs.filter(log =>
    log.event.toLowerCase().includes(searchTerm.toLowerCase()) ||
    log.details.toLowerCase().includes(searchTerm.toLowerCase()) ||
    log.time.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Card>
      <CardContent>
        <Box sx={{ mb: 2 , width:"40%"}}>
          <TextField
                variant="outlined"
                placeholder="Search Log"
                size="small"
                value={searchTerm}
                onChange={(e)=> setSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: 'var(--thm-color)' }} />
                    </InputAdornment>
                  ),
                }}
              />
        </Box>

        <Timeline>
          {filteredLogs.length > 0 ? (
            filteredLogs.map((log, index) => (
              <TimelineItem key={index} position="alternate" sx={{ paddingLeft: 0, marginLeft: 0 }}>
                <TimelineSeparator>
                  <TimelineDot className="activity-dot">{log.icon}</TimelineDot>
                  {index !== filteredLogs.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                  <Typography variant="subtitle2" className="activity-title">{log.event}</Typography>
                  <Typography variant="body2" color="textSecondary" className="activity-history">{log.time}</Typography>
                  <Typography variant="body2" className="activity-content">{log.details}</Typography>
                </TimelineContent>
              </TimelineItem>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', mt: 2 }}>
              No activities found.
            </Typography>
          )}
        </Timeline>
      </CardContent>
    </Card>
  );
}

export default ActivityLog;
 